import classnames from "classnames";
import { useDropdown } from "@/hooks";
import styles from "@/styles/DropdownMenu.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function DropdownMenu(_ref) {
  let {
    mouseOver = false,
    right = false,
    button,
    children,
    scopedClass
  } = _ref;
  const {
    buttonRef,
    contentRef,
    show,
    listeners
  } = useDropdown({
    mouseOver
  });
  return /*#__PURE__*/_jsxs("div", {
    className: `${styles.dropdown} ${scopedClass}`,
    onMouseOver: listeners.handleMouseOver,
    onMouseLeave: listeners.handleMouseLeave,
    children: [/*#__PURE__*/_jsx("div", {
      ref: buttonRef,
      className: classnames(styles.button, scopedClass, {
        [styles.show]: show
      }),
      onClick: listeners.handleClick,
      children: button
    }), /*#__PURE__*/_jsx("div", {
      ref: contentRef,
      className: classnames(styles.content, scopedClass, {
        [styles.show]: show,
        [styles.right]: right
      }),
      children: children
    })]
  });
}